export default __webpack_public_path__ + "static/media/imageDiscription.d5c349b9.png";